import { __awaiter } from '../../../external_node_modules/tslib/tslib.es6.js';
import checkRestrictionUserAge from '../../../utils/userAgeRestriction.js';
import { initWinStoreTransaction } from '../../../external_node_modules/@wg/web2clientapi/platform/WinStore/initWinStoreTransaction.js';
import { EVENTS } from '../../../constants/events.js';
import { PURCHASE_STATUSES } from '../../../constants/purchaseStatuses.js';
import { RESTRICTION_STATUTES } from '../../../constants/restrictionStatus.js';
import events from '../../event/index.js';
import { getCategories } from './categories.js';
import { getProducts } from './products.js';
import { getUser } from './user.js';
import settings from '../../../settings.js';
import { error, log } from '../../../utils/logger.js';
import { redirectToUrl } from '../../../utils/redirectToUrl.js';

function checkout(externalProductId, customStorefrontName, customFields) {
    return __awaiter(this, void 0, void 0, function* () {
        if (settings.fraudDetectionDialogEnabled) {
            events.emit(EVENTS.CHECK_PURCHASE_RESTRICTION);
        }
        const user = yield getUser();
        if (!user.canPurchase) {
            error('[WinStore]', 'User cannot purchase this product', user);
            throw new Error('User cannot purchase this product');
        }
        if (settings.redirectToUserAuthEnabled) {
            if (!user.isLoggedIn && settings.userAuthUrl) {
                redirectToUrl(settings.userAuthUrl);
                throw new Error('User not logged in');
            }
        }
        const productEntities = yield getProducts(customStorefrontName);
        const productEntity = productEntities.find((winStoreProduct) => winStoreProduct.externalProductId === externalProductId);
        if (!productEntity) {
            error('[WinStore]', 'Product not found', externalProductId, productEntity);
            return { purchaseStatus: PURCHASE_STATUSES.ERROR };
        }
        const storefrontName = customStorefrontName || settings.storefrontName;
        if ((yield checkRestrictionUserAge(productEntity, events, user)) === RESTRICTION_STATUTES.CANCELLED) {
            return { purchaseStatus: PURCHASE_STATUSES.CANCELLED };
        }
        try {
            const { productId, inAppOfferToken, currencyCode, price } = (productEntity === null || productEntity === void 0 ? void 0 : productEntity.raw) || {};
            log('[WinStore]', 'Create transaction with params', productId, inAppOfferToken, price, currencyCode);
            yield initWinStoreTransaction(productId, inAppOfferToken, price, currencyCode);
            productEntity.updateLimitAfterSuccessPurchase();
            const categoryEntities = yield getCategories();
            events.emit(EVENTS.PRODUCTS_UPDATE, { storefrontName, products: productEntities });
            events.emit(EVENTS.CATEGORIES_UPDATE, { storefrontName, categories: categoryEntities });
            return { purchaseStatus: PURCHASE_STATUSES.SUCCESS };
        }
        catch (err) {
            error('[WinStore]', 'Purchase has been finished with error', err);
        }
        return { purchaseStatus: PURCHASE_STATUSES.ERROR };
    });
}

export { checkout };
//# sourceMappingURL=checkout.js.map
